<a
  [title]="'Delete' | translate"
  class="ml-1 mr-1 font-medium-2"
  [class.danger]="!disabled"
  [class.text-muted]="disabled"
  (click)="onClick()"

><i class="ft-trash"></i></a>
